import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import '../styles/Register.css';
import CopyButton from "../components/CopyButton";
import * as BsIcons from "react-icons/bs";
import { login } from "../api_folder/api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Container, Form, Alert, InputGroup } from "react-bootstrap";
import { useContext, useState } from "react";
import AuthContext from "../api_folder/AuthProvider";
function RegisterInternalSuccess() {
    const [errMsg, setErrMsg] = useState('');
    const l = useLocation();
    const regex = /(<([^>]+)>)/gi;
    const { setAuth } = useContext(AuthContext);
    let userAuth = [];
    const navigate = useNavigate();

    let usrnm = l.state.username;
    let psswd = l.state.password;

    let handleSubmit = (e) => {
        e.preventDefault();
        login(usrnm, psswd).then((res) => {
            if (res.data.status === 200) {
                userAuth = res.data;
                // localStorage.setItem("token", res.data.token);
                localStorage.setItem("zep2kjzol", res.data.username);
                setAuth(userAuth.username, userAuth.token, userAuth.expireAt)
                navigate('/dashboard', {
                    state: userAuth
                })
            } else if (res.data.status === 'fail') {
                setErrMsg(res.data.message.replace(regex, " "))
            }
        })
    }

    return (
        <section className="p-3">
            <Navbar
                expand="sm"
                variant="custom"
                bsPrefix={""}
                fixed="top"
            >
                <Navbar.Brand>
                    <img
                        src="/images/logo.svg"
                        width="44"
                        height="45"
                        className="d-inline-block align-top ms-3"
                        alt="logo"
                    />
                </Navbar.Brand>
                <Nav className="ms-auto">
                    <Nav.Link
                        className="me-3"
                    >
                        SPMB Asy-Syukriyyah Islamic School
                    </Nav.Link>
                </Nav>
            </Navbar>
            <Container style={{ marginTop: '126px', marginBottom: '120px' }}>
                <Link to="/" className="back" >
                    <BsIcons.BsArrowLeftShort /> Kembali ke halaman utama
                </Link>


                <span className="circlex" />
                <span className="circley" />
                <div className="mt-4">
                    <div style={{ color: '#12b795' }}>
                        <BsIcons.BsCheck2 size={100} />
                        <h1 style={{ color: '#364152', marginTop: '0.5rem' }}>Pendaftaran sukses!</h1>
                    </div>
                    {/* <p className="text-body-regsuccess">Pendaftaran internal telah sukses, Data informasi pendaftaran akan dikirim melalui email (cek inbox/spam).</p> */}
                    <Alert className="mt-3" variant="success">{l.state.message}</Alert>
                    <Form.Label column sm="2">
                        Username
                    </Form.Label>
                    <InputGroup className="flex-nowrap">
                        <Form.Control type="text" value={l.state.username} readOnly />
                        <CopyButton text={l.state.username} label={"username"} />
                    </InputGroup>
                    <Form.Label column sm="2">
                        Password
                    </Form.Label>
                    <InputGroup className="flex-nowrap">
                        <Form.Control defaultValue={l.state.password} readOnly type="text" />
                        <CopyButton text={l.state.password} label={"password"} />
                    </InputGroup>
                    <Alert variant="success" style={{ marginTop: '1rem' }}>Silakan screenshot layar ini atau klik tombol dibawah ini:</Alert>
                    <Button target="_blank" href={l.state.link_download} variant="success" style={{ marginTop: '1.0rem' }}>Print</Button>
                    <Form onSubmit={handleSubmit}>
                        <Button type="submit" variant="success" style={{ marginTop: '1.0rem' }}>Login</Button>
                    </Form>
                    {errMsg ? (
                        <Alert variant="danger" className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</Alert>
                    ) : (
                        <span></span>
                    )}
                </div>
            </Container>

        </section>
    )

}
export default RegisterInternalSuccess;